import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Box, Toolbar, Typography } from '@mui/material';

const Terms = () => {
    const { t } = useLanguage();
    return (
        <Box>
            <Toolbar>
                <div className='terms-screen'>
                    <div className='disclainerWrapper'>
                        <Typography variant='h2'>{t('t_cond_text')}</Typography>
                        <div className='tems-condition-content'>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text1')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_1')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text2')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_2')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text3')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_3')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text4')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_4')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text5')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_5')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text6')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_6')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>{t('t_cond_text7')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_7')}</Typography>
                                <Typography variant='body1'>{t('t_cond_text_7_7')}</Typography>
                            </div>

                        </div>
                    </div>
                </div>
            </Toolbar>
        </Box>
    );
};

export default Terms;